import React, { useContext, useMemo } from 'react';
import { useParams } from 'umi';
import { PAGE_CONFIG } from './pageConfig';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { StudioContext } from '@home/pages/studio/context';

const MULTI_REPORTS_BASE_PATH = '/multiReports';

const MultiReports = () => {
  const { studioId, gameCode, reportKey } = useParams<{
    studioId?: string;
    gameCode?: string;
    reportKey?: string;
  }>() || {};
  const { currentMenu } = useContext(StudioContext);

  const reqParams = useMemo(() => {
    const menuPath = String(currentMenu?.path || '').trim();
    if (
      menuPath &&
      (menuPath === MULTI_REPORTS_BASE_PATH ||
        menuPath.startsWith(`${MULTI_REPORTS_BASE_PATH}/`))
    ) {
      return menuPath.startsWith('/') ? menuPath : `/${menuPath}`;
    }
    return reportKey
      ? `${MULTI_REPORTS_BASE_PATH}/${reportKey}`
      : MULTI_REPORTS_BASE_PATH;
  }, [currentMenu?.path, reportKey]);

  return (
    <CommonPageRender
      key={`${studioId}-${gameCode}-${reqParams}`}
      reqParams={reqParams}
      frameType="game"
      // @ts-ignore
      pageConfigInit={PAGE_CONFIG}
      api={PAGE_CONFIG_API}
    />
  );
};

export default MultiReports;
